<template>
    <div class="d-flex flex-row flex-wrap gap-2 w-100">
        <ChannelStatRowBox class="flex-grow-1"
                           :title="__('orders.orders')"
                           :style="`background-color: ${channelStatistics.integration.color}; color: ${fgColor}`"
        >
            {{ channelStatistics.orders_fulfilled }}
        </ChannelStatRowBox>
        <ChannelStatRowBox class="flex-grow-1"
                           :title="__('orders.value')"
                           :style="`background-color: ${channelStatistics.integration.color}; color: ${fgColor}`"
        >
            <Price :value="channelStatistics.average_order_value"
                   prefix="⌀"
            />
        </ChannelStatRowBox>
        <ChannelStatRowBox class="flex-grow-1"
                           :title="__('orders.sales_volume')"
                           :style="`background-color: ${channelStatistics.integration.color}; color: ${fgColor}`"
        >
            <Price :value="channelStatistics.sales_volume"/>
        </ChannelStatRowBox>
    </div>
</template>

<script>
import Price from "@components/Price.vue";
import ChannelStatRowBox from "@components/Stats/Components/ChannelStatRowBox.vue";
import tinycolor from "tinycolor2";

export default {
    components: {ChannelStatRowBox, Price},

    props: {
        channelStatistics: Object
    },

    computed: {
        fgColor() {
            let color = tinycolor(this.channelStatistics.integration.color)
            if (color.isLight()) {
                return color.desaturate(40).darken(40);
            }
            return color.desaturate(40).lighten(30);
        }
    }
}
</script>
